module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/fire-4605fcff352487660a6c77074a3157b7.svg";